import React from 'react';
import {UserX} from 'lucide-react';
import RenderIf from "@/components/render-if";
import {formatDate} from "@/lib/helper/date";
import {AbsenceTypeEnum} from "@/lib/helper/enumType";
import {Tag} from "antd";

function AbsenceSection({id, takenunit}) {


    if (!takenunit) return null;
    if (takenunit?.data?.data?.absences?.length === 0) {
        return null;
    }


    return (
        <>
            {/* Assignments Section */}
            <div className="rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-600">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-red-100 rounded-lg">

                        <UserX className="w-6 h-6 text-red-600"/>
                    </div>
                    <h2 className="text-2xl font-bold  ">غیبت‌های شما

                    </h2>
                </div>


                <div className="space-y-4">
                    <RenderIf condition={takenunit?.data?.data?.absences?.length > 0}>
                        {takenunit?.data?.data?.absences?.map((absence, index) => (
                            <div key={absence.id + '-' + index}
                                 className="border dark:border-gray-600 rounded-xl p-5 hover:shadow-md transition-all duration-200">
                                <div className="flex items-start justify-between mb-4 flex-wrap">
                                    <div className="flex gap-2 justify-between">
                                        <div className="">
                                            {index + 1}.
                                            <span className="text-sm "> تاریخ غیبت :

                                        </span>
                                            {formatDate(absence.date, 'YYY-MM-DD')}
                                        </div>

                                        <div>
                                            <Tag
                                                className={AbsenceTypeEnum(absence?.type, 'color')}>{AbsenceTypeEnum(absence?.type)}</Tag>
                                        </div>

                                    </div>

                                </div>


                            </div>
                        ))}
                    </RenderIf>

                </div>
            </div>

        </>
    );
}

export default AbsenceSection;